module.exports = __webpack_public_path__ + "images/forest/impact-01.e00dd1c331d54685e8fd3dd107f6b8bc.jpg";